import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/app/store';
import { useUserClientContext } from '@/app/clientContext';
import { resetClientScopedApiState } from '@/features/resetClientApiState';

export const useResetClientAndApiState = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { refreshClientMetadata } = useUserClientContext();
  const reset = useCallback(() => {
    refreshClientMetadata();
    resetClientScopedApiState(dispatch);
  }, [dispatch, refreshClientMetadata]);
  return reset;
};
